export default __webpack_public_path__ + "static/media/phoenix-announcement-enabled-icon.cb1cb5ad.svg";